var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBkgLogo = function SvgBkgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "284px",
    height: "281px",
    viewBox: "0 0 284 281",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "bg_logo")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143,0 L143,69.9572193 L70.928,69.9572193 L70.928,140.47861 L143,140.47861 L143,211 L106.964,211 C47.8893653,211 0,163.766089 0,105.5 C0,47.2339109 47.8893653,0 106.964,0 L143,0 Z M141,70 L176.75,70 C235.982507,70 284,117.233991 284,175.5 C284,233.766009 235.982507,281 176.75,281 L141,281 L141,210.666667 L213.072,210.666667 L213.072,140.333333 L141,140.333333 L141,70 Z",
    id: "bg_logo",
    fill: "#4B13E8"
  }))));
};
export default SvgBkgLogo;